
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 1a7 7 0 107 7 7 7 0 00-7-7zm0 12.69A5.69 5.69 0 1113.69 8 5.69 5.69 0 018 13.69zm.5-5.76V4a.5.5 0 00-1 0v4a.49.49 0 00.42.48l3.08 2.4a.4.4 0 00.57 0 .4.4 0 000-.56z"}})])
          )
        }
      }
    